import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Pagination/Pagination.Label.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var PaginationLabel = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd:pagination__label", className),
    children
  }));
};
var Pagination_Label_default = PaginationLabel;
export { Pagination_Label_default };